import { string } from 'yup';

export function getDateSchema() {
  return string().required('generic.pleaseSelectAnOption').defined().default('');
}
